import React from 'react'
import { RegisterUserType1 } from './RegisterUserType1/RegisterUserType1';
import { RegisterUserType2 } from './RegisterUserType2/RegisterUserType2';
import './RegisterUser.css';

export const RegisterUser = (props) => {
    const typeOfUserToRegister = props.match.params['userType'];

    // API SEND and STATE Handlers

    if (typeOfUserToRegister === 'user1') {
        return (
            <RegisterUserType1 
              initiateRealLogIn={props.initiateRealLogIn}
            />
        )
    } else if (typeOfUserToRegister === 'user2') {
        return (
            <RegisterUserType2
                 initiateRealLogIn={props.initiateRealLogIn}
             />
        )
    } else {
        return (
            <div> 
                User for registration is not selected
            </div>
        )
    }
}
